import React, { Component } from 'react';

import App from './App';
// import { ConnectedRouter } from 'react-router-redux';
import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import { persistor, store } from 'store/configureStore';
import { PersistGate } from 'redux-persist/lib/integration/react';

class Root extends Component {
  render() {
    const { history } = this.props;
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <>
              <ScrollToTop>
                <Route path="/" component={App} />
              </ScrollToTop>
            </>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default Root;
